import React, {Component} from 'react';
import * as messageConstants from '../../shared/messages';

class AppNames extends Component {

  render() {
    return (
        <div className="row">
          <div className="col-xs-12 col-sm-8">
            <div className="sba-name-placeholder">
              <label
                  className="sba-label-title">{messageConstants.SBA_APPNAME_LABEL}</label>
              <input
                  id="sbaApplicationNameInput"
                  type="text"
                  className="form-control app-name"
                  value={this.props.applicationName}
                  onChange={this.props.handleChangeAppName}
                  placeholder="This name is visible only to admins"
                  onBlur={this.props.handleUserFriendlyNameBlur}
              /></div>

            <div className="sba-name-placeholder">
              <label
                  className="sba-label-title">{messageConstants.SBA_APPNAME_USER_FRIENDLY_LABEL}</label>
              <input
                  id="sbaUserFriendlyNameInput"
                  type="text"
                  className="form-control app-name"
                  value={this.props.userFriendlyName}
                  onChange={this.props.handleChangeUserFriendlyName}
                  placeholder="This name is visible to application users"
                  onBlur={this.props.handleUserFriendlyNameBlur}
              /></div>
          </div>
        </div>
    );
  }
}

export default AppNames;
